<div class="row">
    <div class="col-12">
        <div id="clientList" class="card">
            <app-list-layout [tableConfig]="tableConfig" [listItems]="listItems"
                [listService]="invoiceListService" (buttonActionSelected)="buttonActionSelected($event)"
                (updateCheckedValues)="checkedValGet =  $event" (rowActionSelected)="rowActionSelected($event)"
                (filterSelected)="filterSelected($event)" (sortSelected)="sortByPassedSort($event)"
                (searchTermChanged)="invoiceListService.searchTerm = $event"
                (resetListLayout) = "invoiceListService.resetListState($event)"
                (dateRangeChanged) = "invoiceListService.rangeDate = $event"
                (paginationSelected)="paginationUpdated(invoiceListService,$event)" [serviceData]="serviceData"
                (pageSizeSelected)="invoiceListService.pageSize = $event"></app-list-layout>
        </div>
    </div>
</div>